<script>
import Notification from '../reUse/Notification.vue';
import {i18n} from '@/i18n'
import {markRaw} from 'vue'
import {ScheduleXCalendar} from '@schedule-x/vue'
import {
  createCalendar,
  createViewDay,
  createViewMonthAgenda,
  createViewMonthGrid,
  createViewWeek,
  createViewWeekAgenda,
} from '@schedule-x/calendar'
import {createEventsServicePlugin} from '@schedule-x/events-service'
import '@schedule-x/theme-default/dist/index.css'
import 'temporal-polyfill/global'
import { translations, mergeLocales } from '@schedule-x/translations'
import Multiselect from 'vue-multiselect'
import sl from '@/Prevodi/Razpolozljivost-sl.json';
import en from '@/Prevodi/Razpolozljivost-en.json';
import it from '@/Prevodi/Razpolozljivost-it.json';
export default {
  components: {
    ScheduleXCalendar,
    Notification,
    Multiselect
  },
  props: {
    osvezi: Boolean,
    user: Object,
    letala: Object
  },
  emits: ['odjava'],
  data() {
    return {
      vnosi: [],
      koledar: null,
      datum: null,
      uraOd: null,
      uraDo: null,
      dodan: null,
      urejen: null,
      opomba: null,
      idUrejanja: null,
      posodabljanje: false,
      brisanje: false,
      iskalnik: '',
      prikaz: 'vsi',
      koledarPrikaz: ['jadranje', 'letenje', 'vleka'],
      //NOTIFICATION
      ShowNoti: false,
      text: '',
      types: '',
      izbrani: []
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  watch: {
    osvezi(novOsvezi, starOsvezi) {
      if (novOsvezi) {
        this.BeriPodatke();
      }
    },
    PrikazLetal(novo, staro) {
      if(novo) {
        this.OsveziKoledar();
      }
    },
    vnosi(novo, staro) {
      if(novo) {
        this.izbrani.push('');
        setTimeout(() => {
          this.izbrani.pop();
        },200);

      }
    }
  },
  mounted() {
    this.BeriPodatke();
    this.CreateCalendar();
  },
  computed: {
    PrikazLetal() {
      if(this.izbrani.length > 0) {
        return this.vnosi.filter(letalo => this.izbrani.includes(letalo.letalo_reg));
      }
      return this.vnosi;
    }
  },
  methods: {
    BeriPodatke(zacetek, konec) {
      // const {createEventsServicePlugin} = window.SXEventsService;
      axios.get('./api/razpolozljivost/letala/beri/', {withCredentials: true}).then((response) => {
        // if(this.user.jadralni_pilot && this.user.lvl > 2 && !this.user.motorni_pilot) { //če je jadralni pilot pokažemo samo zapise za vleko, za 1x vidijo vsi vse
        //   this.vnosi = response.data.vnosi.filter(zapis => zapis.vlecni_rating == true);
        // }else {
        //   this.vnosi = response.data.vnosi;
        // }
        this.vnosi = response.data.vnosi;
        const events = this.vnosi.map(event => ({
          ...event,

          start: Temporal.PlainDateTime
              .from(event.start)
              .toZonedDateTime('Europe/Ljubljana'),

          end: Temporal.PlainDateTime
              .from(event.end)
              .toZonedDateTime('Europe/Ljubljana'),
        }))
        // this.koledar.$app.calendarEvents.list.set(this.vnosi)
        this.koledar.events.set(events);


      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
      });
    },
    CreateCalendar() {
      const app = this;
      const eventsServicePlugin = createEventsServicePlugin()

      this.koledar = markRaw(
          createCalendar(
              {
                timezone: 'Europe/Ljubljana',
                locale: app.PridobiJezik(),
                translations: mergeLocales(
                    translations,
                    {
                      slSI: {
                        'Week Agenda': 'Tedenski pregled',
                      },
                    }
                ),
                defaultView: 'week',

                calendars: {
                  vleka: {
                    colorName: 'vleka',
                    lightColors: {
                      main: '#606c38',
                      container: '#007200',
                      onContainer: '#ffffff',
                    },
                    darkColors: {
                      main: '#fff5c0',
                      onContainer: '#fff5de',
                      container: '#307ACC',
                    },
                  },

                  letenje: {
                    colorName: 'letenje',
                    lightColors: {
                      main: '#606c78',
                      container: '#007200',
                      onContainer: '#ffffff',
                    },
                    darkColors: {
                      main: '#c3996b',
                      onContainer: '#fff2df',
                      container: 'rgba(128, 50, 50, 0.8)',
                    },
                  },

                  jadranje: {
                    colorName: 'jadranje',
                    lightColors: {
                      main: '#606c78',
                      container: '#007200',
                      onContainer: '#ffffff',
                    },
                    darkColors: {
                      main: '#c3996b',
                      onContainer: '#eeeeee',
                      container: '#cd7840',
                    },
                  },

                  letala: {
                    colorName: 'letala',
                    lightColors: {
                      main: '#606c78',
                      container: '#007200',
                      onContainer: '#ffffff',
                    },
                    darkColors: {
                      main: '#634eac',
                      onContainer: '#eeeeee',
                      container: '#634eac',
                    },
                  },
                },

                monthGridOptions: {
                  nEventsPerDay: 30,
                },

                isDark: true,

                views: [
                  createViewWeek(),
                  createViewWeekAgenda(),
                  createViewMonthGrid(),
                  createViewMonthAgenda()
                ],

                events: [],

                callbacks: {
                  onRangeUpdate(range) {
                    app.BeriPodatke(range.start, range.end)
                  },

                  onEventClick(event) {
                    app.OdpriModal(event)
                  },
                },
              },
              [eventsServicePlugin]
          )
      )
    },
    OdpriModal(event) {
      this.datum = event.datum;
      this.uraOd = event.ura_zacetka;
      this.uraDo = event.ura_konca;
      this.idUrejanja = event.id;
      this.dodan = event.zapis_dodan;
      this.urejen = event.zapis_urejen;
      this.opomba = event.opomba;
      $(this.$refs.modalUrejanjaZapisa).modal('show');
      setTimeout(() => {
        $('#datum_uredi').focus();
      }, 200);
    },
    ZapriModal() {
      $(this.$refs.modalUrejanjaZapisa).modal('hide');
    },
    Uredi() {
      if (this.uraOd < this.uraDo) {
        this.posodabljanje = true;
        var podatki = new URLSearchParams();
        podatki.append('id', this.idUrejanja);
        podatki.append('datum', this.datum);
        podatki.append('ura_zacetka', this.uraOd);
        podatki.append('ura_konca', this.uraDo);
        podatki.append('letalo_id', this.vnosi.filter(zapis => zapis.id === this.idUrejanja)[0].letalo_id);
        podatki.append('letalo_reg', this.vnosi.filter(zapis => zapis.id === this.idUrejanja)[0].letalo_reg);
        podatki.append('opomba', (this.opomba !== '') ? this.opomba : null);
        axios.post('./api/razpolozljivost/letala/uredi/', podatki, {withCredentials: true}).then((response) => {
          this.posodabljanje = false;
          for (var i = 0; i < this.vnosi.length; i++) {
            if (this.vnosi[i].id === this.idUrejanja) {
              this.vnosi[i].datum = this.datum;
              this.vnosi[i].ura_zacetka = this.uraOd;
              this.vnosi[i].ura_konca = this.uraDo;
              this.vnosi[i].start = this.datum + ' ' + this.uraOd;
              this.vnosi[i].end = this.datum + ' ' + this.uraDo;
              this.vnosi[i].zapis_urejen = this.PridobiDatumCas();
              this.vnosi[i].opomba = this.opomba;
              if(this.opomba !== '') {
                this.vnosi[i].title = this.vnosi[i].letalo_reg+ "("+this.vnosi[i].opomba+")";
              }else {
                this.vnosi[i].title = this.vnosi[i].letalo_reg;
              }

            }
          }
          this.OsveziKoledar();
          this.text = "Vnos uspešno posodobljen";
          this.types = "Uspešno";
          this.ShowNoti = true;
          $(this.$refs.modalUrejanjaZapisa).modal('hide');
          this.datum = null;
          this.uraOd = null;
          this.uraDo = null;
          this.dodan = null;
          this.urejen = null;
          this.opomba = null;
        }).catch((napaka) => {
          this.posodabljanje = false;
          this.text = "Prišlo je do napake pri posodabljanju podatkov";
          this.types = "Napaka";
          this.ShowNoti = true;
        });
      } else {
        $('#uraOdEdit').removeClass('border-0').css('border', '1px solid red');
        this.text = this.$t('obvestila.casVnosa');
        this.types = "Napaka";
        this.ShowNoti = true;
        setTimeout(() => {
          $('#uraOdEdit').removeAttr('style').addClass('border-0');
        }, 10000);
      }
    },
    Brisi() {
      this.brisanje = true;
      var podatki = new URLSearchParams();
      podatki.append('idBrisanja', this.idUrejanja);
      podatki.append('pilot_id', this.vnosi.filter(zapis => zapis.id === this.idUrejanja)[0].pilot_id);
      podatki.append('datum', this.vnosi.filter(zapis => zapis.id === this.idUrejanja)[0].datum);
      podatki.append('ura_zacetka', this.vnosi.filter(zapis => zapis.id === this.idUrejanja)[0].ura_zacetka);
      podatki.append('ura_konca', this.vnosi.filter(zapis => zapis.id === this.idUrejanja)[0].ura_konca);
      podatki.append('letalo_id', this.vnosi.filter(zapis => zapis.id === this.idUrejanja)[0].letalo_id);
      podatki.append('letalo_reg', this.vnosi.filter(zapis => zapis.id === this.idUrejanja)[0].letalo_reg);
      axios.post('./api/razpolozljivost/letala/brisi/', podatki, {withCredentials: true}).then((response) => {
        var nVnosi = [];
        for (let i = 0; i < this.vnosi.length; i++) {
          if (this.vnosi[i].id !== this.idUrejanja) {
            nVnosi.push(this.vnosi[i]);
          }
        }
        this.vnosi = nVnosi;
        this.OsveziKoledar();
        this.text = "Vnos uspešno izbrisan";
        this.types = "Uspešno";
        this.ShowNoti = true;
        this.brisanje = false;
        $(this.$refs.modalUrejanjaZapisa).modal('hide');
      }).catch((napaka) => {
        this.text = "Prišlo je do napake pri posodabljanju podatkov";
        this.types = "Napaka";
        this.ShowNoti = true;
        this.brisanje = false;
      });
    },
    PraviceUrejanjaBrisanja() {
      if (this.vnosi.some(zapis => zapis.id === this.idUrejanja && Number(zapis.pilot_id) === Number(this.user.id))) {
        return true;
      } else {
        if (this.user.lvl < 2) {
          return true;
        }
        return false;
      }
    },
    PridobiDatumCas() {
      const now = new Date();

      const d = String(now.getDate()).padStart(2, '0');
      const m = String(now.getMonth() + 1).padStart(2, '0');
      const Y = now.getFullYear();

      const H = String(now.getHours()).padStart(2, '0');
      const i = String(now.getMinutes()).padStart(2, '0');
      const s = String(now.getSeconds()).padStart(2, '0');

      return `${d}.${m}.${Y} ${H}:${i}:${s}`;
    },
    PridobiJezik() {
      switch (this.$i18n.locale) {
        case 'sl':
          return 'sl-SI';
          break;
        case 'it':
          return 'it-IT';
          break;
        case 'en':
          return 'en-EN';
          break;
        default:
          return 'sl-SI';
      }
    },
    KoledarFilter(vnos) {
      if (!this.koledarPrikaz.includes(vnos)) {
        this.koledarPrikaz.push(vnos);
      } else {
        var filter = [];
        for (var i = 0; i < this.koledarPrikaz.length; i++) {
          if (this.koledarPrikaz[i] !== vnos) {
            filter.push(this.koledarPrikaz[i]);
          }
        }
        this.koledarPrikaz = filter;
      }
      if (!this.koledarPrikaz?.length) {
        this.koledar.events.set(this.vnosi);
      }
      const events = this.vnosi.map(event => ({
        ...event,

        start: Temporal.PlainDateTime
            .from(event.start)
            .toZonedDateTime('Europe/Ljubljana'),

        end: Temporal.PlainDateTime
            .from(event.end)
            .toZonedDateTime('Europe/Ljubljana'),
      }));
      this.koledar.events.set(events.filter(zapis =>
          this.koledarPrikaz.includes(zapis.calendarId)
      ));
    },
    OsveziKoledar() {
      const events = this.PrikazLetal.map(event => ({
        ...event,

        start: Temporal.PlainDateTime
            .from(event.start)
            .toZonedDateTime('Europe/Ljubljana'),

        end: Temporal.PlainDateTime
            .from(event.end)
            .toZonedDateTime('Europe/Ljubljana'),
      }))
      // this.koledar.$app.calendarEvents.list.set(this.vnosi)
      this.koledar.events.set(events);
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    }
  }
}
</script>
<template>
  <div class='container mt-4'>
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false" />
    </Transition>
    <div class='row'>
      <div class='col-12 text-center mt-2 h-auto'>
        <div class='row d-flex justify-content-center'>
          <div class="col-12 col-md-4 ">
            <div class="container">
              <div class="label-date p-2 col-4 text-start">{{$t('labelsR.filtriraj')}}</div>
              <multiselect class="mt-2 mb-2 wingsi-multiselect" id="tagging" v-model="izbrani"
                           :placeholder="$t('labelsR.isci')"
                           :options="letala" :multiple="true"
                           :selectLabel="$t('labelsR.izberi')"
                           :deselectLabel="$t('labelsR.odstrani')"
                           :selectedLabel="$t('labelsR.izbrano')"
              >
                <template #noResult>
                  {{ $t('labelsR.neObstaja') }}
                </template>
                <template #noOptions>
                  {{ $t('labelsR.praznaLista') }}
                </template>
              </multiselect>
            </div>
          </div>
        </div>
      </div>
      <!-- KOLEDAR -->
      <div  class="calendar col-md-10 offset-md-1">
        <ScheduleXCalendar v-if="koledar" :calendar-app="koledar" />
      </div>
      <div class="col-12 p-5"></div>
    </div>
    <!-- UREJANJE/BRISANJE ZAPISA MODAL -->
    <div class="modal modal-kartica" ref="modalUrejanjaZapisa" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content list-dark border-orange">
          <div class='d-flex justify-content-end'>
            <button class="modern-close-btn mt-2 me-2" @click.prevent="ZapriModal">
              <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
            </button>
          </div>
          <!-- Navigation Tabs -->
          <div class='modal-header justify-content-between'>
            <h5 class="card-title"><i class="fas fa-edit fa-lg"></i> {{$t('labelsR.UrejanjeZapisa')}}</h5>
          </div>
          <div class="modal-body col-12">
            <div class="container">
              <!-- DATUM -->
              <div class="col-12">
                <div class="container">
                  <div class="label-date p-2 col-6" for="datum">{{$t('labelsR.datum')}}</div>
                  <input :disabled="posodabljanje || !this.PraviceUrejanjaBrisanja()" class="input border-0 rounded-4 p-2 fs-5" type="date" id="datum_uredi" v-model="datum" />
                </div>
              </div>
              <div class='row'>
                <!-- URA OD -->
                <div class="col-6">
                  <div class="container">
                    <div class="label-date p-2 col-12" for="uraOd">{{$t('labelsR.uraOd')}}</div>
                    <input :disabled="posodabljanje || !this.PraviceUrejanjaBrisanja()" class="input border-0 rounded-4 p-2 fs-5" type="time" id="uraOdEdit" v-model="uraOd" />
                  </div>
                </div>
                <!-- URA DO -->
                <div class="col-6">
                  <div class="container">
                    <div class="label-date p-2 col-12" for="uraDo">{{$t('labelsR.uraDo')}}</div>
                    <input :disabled="posodabljanje || !this.PraviceUrejanjaBrisanja()" class="input border-0 rounded-4 p-2 fs-5" type="time" id="uraDo" v-model="uraDo" />
                  </div>
                </div>
              </div>
              <div class='row'>
                <!-- OPOMBA -->
                <div class="col-12">
                  <div class="container">
                    <div class="row d-flex">
                      <div class="label-date ms-2 p-2 col-6">{{$t('labelsR.opomba')}} </div>
                      <div class="label-date p-2 col-4 text-end">
                        <span class="opomba-text" :class="{'text-danger': this.opomba !== null && this.opomba.length >= 90}">{{ (this.opomba !== null) ? this.opomba.length : 0}} / 100</span>
                      </div>
                    </div>
                    <input :disabled="posodabljanje || !this.PraviceUrejanjaBrisanja()" class="input border-0 rounded-4 p-2 fs-5" maxlength="100" type="text" id="uraOdEdit" v-model="opomba" />
                  </div>
                </div>
              </div>
            </div>
            <div class='row'>
              <div class='col-xl-6 text-center'>
                <div class='container mt-4 mt-md-4 mt-xl-5'>
                  <button @click.prevent="Uredi()" class="btn btn-primary border-0 rounded-4 w-100 d-flex justify-content-center" :disabled="posodabljanje || !this.PraviceUrejanjaBrisanja()" data-umami-event="Razpolozljivost-urejanje-posodobi">{{$t('buttons.urediZapis')}} <i class="fas fa-edit" :class="{'fa-spin': posodabljanje}"></i></button>
                </div>
              </div>
              <div class='col-xl-6 text-center'>
                <div class='container mt-4 mt-md-4 mt-xl-5'>
                  <button @click.prevent="Brisi()" class="btn btn-danger border-0 rounded-4 w-100 d-flex justify-content-center" :disabled="brisanje || !this.PraviceUrejanjaBrisanja()" data-umami-event="Razpolozljivost-urejanje-brisanje">{{$t('buttons.brisiZapis')}} <i class="fas fa-trash" :class="{'fa-spin': brisanje}"></i></button>
                </div>
              </div>
              <!-- DODANO / UREJENO -->
              <div class='col-xl-6 text-center'>
                <div class='container mt-4 mt-md-4 mt-xl-5'>
                  <span class='fs-6 text-white-50'>Zapis dodan:<br/> {{dodan}}</span>
                </div>
              </div>
              <div class='col-xl-6 text-center'>
                <div class='container mt-4 mt-md-4 mt-xl-5'>
                  <span class='fs-6 text-white-50'>Zapis spremenjen:<br/> {{urejen}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.wingsi-multiselect .multiselect__tags {
  border-radius: 8px;
}

.wingsi-multiselect .multiselect__tag {
  background: #634eac;
}

.wingsi-multiselect .multiselect__option--highlight {
  background: #f2ddbd;
}

.wingsi-multiselect .multiselect__option--selected {
  background: #f2ddbd;
  color: #333;
}
.wingsi-multiselect .multiselect__tag-icon::after {
  color: #fff;
}
.wingsi-multiselect .multiselect__tags {
  background: #293136;
  border-radius: 8px;
  border-color: #293136;
}

.wingsi-multiselect .multiselect__input {
  background: #293136;
  color: #fff;
}

.wingsi-multiselect .multiselect__input::placeholder {
  color: #fff;
  opacity: 0.6;
}

.wingsi-multiselect .multiselect__placeholder {
  color: #fff;
}

.wingsi-multiselect .multiselect__option {
  background: #ececec;
  color: #293136;
}
.multiselect__option--highlight {
  background: #307acc;
}

.multiselect__option--highlight:after {
  color: #293136;
  background: #ececec;
}
.wingsi-multiselect .multiselect__option--highlight {
  background: #634eac !important;
  color: #fff !important;
}

.wingsi-multiselect .multiselect__option--highlight:after {
  color: #fff !important;
  background: transparent !important;
}

.wingsi-multiselect .multiselect__option--selected {
  color: #293136;
}
.wingsi-multiselect .multiselect__single {
  padding: 10px;
}
.sx__view-selection-selected-item {
  color: #fff !important;
  font-family: inherit;
}
.sx__view-selection-item {
  color: #fff !important;
}
.calendar {
  min-height: 30vh;
  max-height: 60vh;
  overflow-y: scroll;
}
</style>